module.exports = __webpack_public_path__ + "img/upmood_band_real_small2.343ea564.png";